export default __webpack_public_path__ + "static/media/fireworks.afe08e83.svg";